import { render } from "./BomValidationVersionToggle.vue?vue&type=template&id=34294564&scoped=true"
import script from "./BomValidationVersionToggle.vue?vue&type=script&lang=js"
export * from "./BomValidationVersionToggle.vue?vue&type=script&lang=js"

import "./BomValidationVersionToggle.vue?vue&type=style&index=0&id=34294564&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34294564"]])

export default __exports__